/**
 * @deprecated use toMaskedPhoneNumber instead
 */
export const maskPhoneNumber = (digits: string) => toMaskedPhoneNumber(digits)

export const toMaskedPhoneNumber = (digits: string) => {
  const cleaned = cleanDialstring(digits)
  if (cleaned.startsWith('#') || cleaned.startsWith('*')) {
    return cleaned
  }
  if (cleaned.length > 10) return cleaned
  if (cleaned.length > 7) {
    return `(${cleaned.substring(0, 3)}) ${cleaned.substring(
      3,
      6,
    )}-${cleaned.substring(6)}`
  }
  if (cleaned.length > 4) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3)}`
  }
  return cleaned
}

export const cleanDialstring = (phone: string) => {
  return phone.replace(/[^0-9*#,]+/g, '')
}
